import React from "react";
import {defineBlock, smartProps, useInspectorControl, useSmartProp, useEditor} from "@smartfire/wordpress-react";
import { PanelBody, PanelRow, TextControl } from '@wordpress/components';
import useMedia from 'use-media';
import style from "./block.module.scss";

function Inspector(){
    const [height, setHeight] = useSmartProp("height");
    const [mobileHeight, setMobileHeight] = useSmartProp("mobileHeight");
    const [couleurFond, setCouleurFond] = useSmartProp("couleurFond");
 
    return <>
            <PanelBody title="Configuration Hauteur" initialOpen={true}>
                <PanelRow>
                    <TextControl
                        label={"Hauteur du séparateur (px)"}
                        value={height}
                        onChange={(value) => setHeight(value)}
                    />
                </PanelRow>
                <PanelRow>
                    <TextControl
                        label={"Hauteur du séparateur mobile (px)"}
                        value={mobileHeight}
                        onChange={(value) => setMobileHeight(value)}
                    />
                </PanelRow>
                <PanelRow>
                    <TextControl
                        label={"Couleur HTML fond"}
                        value={couleurFond}
                        onChange={(value) => setCouleurFond(value)}
                    />
                </PanelRow>
            </PanelBody>
        </>;
}

function Block({height,mobileHeight, couleurFond}){
    useInspectorControl(Inspector);
    const {isEditing} = useEditor();

    const isMobile = useMedia({maxWidth: style.mobileBreakpoint});
    const spacerHeight = isMobile ? mobileHeight : height;

    return (
        <div className={style.block} style={{height: spacerHeight+"px", backgroundColor: couleurFond}}>{isEditing && 'Spacer:'}</div>
    );

}

export default defineBlock({
    Block,
    smartProps: {
        height: smartProps.string.withDefault(50),
        mobileHeight: smartProps.string.withDefault(30),
        couleurFond: smartProps.string.withDefault("transparent")
    },
    setup: {
        title: "Spacer",
    }
});
